import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const SIZE = {
	SMALL: 'small',
	STANDARD: 'standard',
};

export const TimesheetsIcon = ({size, color, onClick}) => {
	const getWidth = size => {
		switch (size) {
			case SIZE.SMALL:
				return '13';
			case SIZE.STANDARD:
				return '24';
			default:
				return '24';
		}
	};
	const getHeight = size => {
		switch (size) {
			case SIZE.SMALL:
				return '13';
			case SIZE.STANDARD:
				return '24';
			default:
				return '24';
		}
	};

	const handleClick = e => {
		/*
			We only want to stop propagation if onClick is set i props
			otherwise we want the click to propagate up
		*/
		if (onClick) {
			e.stopPropagation();
			onClick(e);
		}
	};

	return (
		<StyledSpan onClick={handleClick} width={getWidth(size)} height={getHeight(size)}>
			<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					d="M16.5 0.001L12.361 0H5.642L1.5 0.001L1.35554 0.00786658C0.594888 0.0805513 0 0.721304 0 1.501V20.501L0.00686658 20.6455C0.0795513 21.4061 0.720304 22.001 1.5 22.001H9.5L9.58988 21.9929C9.82312 21.9506 10 21.7465 10 21.501C10 21.2249 9.77614 21.001 9.5 21.001H1.5L1.41012 20.9929C1.17688 20.9506 1 20.7465 1 20.501V1.501L1.00806 1.41112C1.05039 1.17788 1.25454 1.001 1.5 1.001H5.952H12.052H16.5L16.5899 1.00906C16.8231 1.05139 17 1.25554 17 1.501L16.9979 8.50143L17.0059 8.59131C17.0483 8.82456 17.2524 9.00143 17.4979 9.00143C17.774 9.00143 17.9979 8.77758 17.9979 8.50143L18 1.501L17.9931 1.35654C17.9204 0.595888 17.2797 0.001 16.5 0.001ZM14.001 6.501C14.001 6.22486 13.7771 6.001 13.501 6.001H4.4977L4.40782 6.00906C4.17457 6.05139 3.9977 6.25554 3.9977 6.501C3.9977 6.77714 4.22155 7.001 4.4977 7.001H13.501L13.5908 6.99294C13.8241 6.95061 14.001 6.74646 14.001 6.501ZM10.5 10.001C10.7761 10.001 11 10.2249 11 10.501C11 10.7465 10.8231 10.9506 10.5899 10.9929L10.5 11.001H4.4977C4.22155 11.001 3.9977 10.7771 3.9977 10.501C3.9977 10.2555 4.17457 10.0514 4.40782 10.0091L4.4977 10.001H10.5ZM9 14.501C9 14.2249 8.77614 14.001 8.5 14.001H4.4977L4.40782 14.0091C4.17457 14.0514 3.9977 14.2555 3.9977 14.501C3.9977 14.7771 4.22155 15.001 4.4977 15.001H8.5L8.58988 14.9929C8.82312 14.9506 9 14.7465 9 14.501ZM11 17.501C11 13.9111 13.9101 11.001 17.5 11.001C21.0899 11.001 24 13.9111 24 17.501C24 21.0909 21.0899 24.001 17.5 24.001C13.9101 24.001 11 21.0909 11 17.501ZM23 17.501C23 14.4634 20.5376 12.001 17.5 12.001C14.4624 12.001 12 14.4634 12 17.501C12 20.5386 14.4624 23.001 17.5 23.001C20.5376 23.001 23 20.5386 23 17.501ZM17.9919 14.4111C17.9496 14.1779 17.7455 14.001 17.5 14.001C17.2239 14.001 17 14.2249 17 14.501V17.501L17.0081 17.5909C17.0504 17.8241 17.2545 18.001 17.5 18.001H19.5L19.5899 17.9929C19.8231 17.9506 20 17.7465 20 17.501L19.9919 17.4111C19.9496 17.1779 19.7455 17.001 19.5 17.001H18V14.501L17.9919 14.4111Z"
					fill={color}
				/>
			</svg>
		</StyledSpan>
	);
};

TimesheetsIcon.SIZE = SIZE;
TimesheetsIcon.propTypes = {
	onClick: PropTypes.func,
	color: PropTypes.string.isRequired,
	size: PropTypes.oneOf([SIZE.SMALL, SIZE.STANDARD]),
};

TimesheetsIcon.defaultProps = {
	color: '#535353',
};

const StyledSpan = Styled.span`
	display: inline;
	height: ${props => props.height + 'px'};
	width: ${props => props.width + 'px'};
`;
